export default __webpack_public_path__ + "static/media/close-circle.dcc67d84.svg";